export function Theme_getDefaultTheme(): ITheme {
    const defaultTheme: ITheme = {
        branding: {
            is_gradient_background: true,
            use_preset_theme: true,
            preset_theme: 'dark-neon',
            enable_noise_texture: true,
            layout_size: 'compact',
            page_bg: { color: 'rgba(70, 118, 216, 1)', secondary_color: 'rgba(70, 118, 216, 1)', gradient_angle: 0 }, // -- background
            soft_text: { color: 'rgba(240, 243, 247, 1)' },
            text: { color: 'rgba(240, 243, 247, 1)' },
            card: { color: 'rgba(216, 205, 255, 0.2)' },
            softHighlight: { color: 'rgba(43, 55, 150, 0.41)' },
            primary: { color: 'rgba(10, 10, 122, 1)' },
            secondary_bg: { color: 'rgba(58, 141, 214, 1)' },
            info: { color: 'rgba(112, 107, 255, 1)' },
            success: { color: 'rgba(122, 255, 131, 1)' },
            error: { color: 'rgba(255, 97, 97, 1)' },
            warning: { color: 'rgba(222, 255, 112, 1)' },
            border: { color: 'rgba(229, 231, 235, 1)' },
            input: { color: 'rgba(243, 244, 246, 1)' },
            ring: { color: 'rgba(243, 244, 246, 1)' },
            landing_banner: {
                image: '',
                description: '',
                button_text: '',
                button_link: '',
                button_color: '',
                button_text_color: '',
                button_variant: 'default',
                image_fit: 'cover'
            }
        }
    }

    return defaultTheme
}
